<div class="detail-box">
    <ng-container *ngFor="let keys of keysGroup">
        <ng-container *ngFor="let item of keys;">
            <ng-container *ngIf="item?.type !== 'TABLE'">
                <div class="detail-item">
                    <p class="detail-label">{{item?.label}}</p>
                    <h6 *ngIf="item?.key; else detailDefaultValue"
                        [ngClass]="{'hidden-input-field': item.hidden && hidePersonalData}">{{ getValueByPath(detail,
                        item)
                        }}</h6>
                    <ng-template #detailDefaultValue>
                        <h6>{{ item?.defaultValue }}</h6>
                    </ng-template>
                </div>
            </ng-container>
            <ng-container *ngIf="item?.type === 'TABLE'">
                <div class="detail-item-table">
                    <ng-container>
                        <ng-container  *ngIf="getTableList(item) as tableList;" >
                            <ng-container *ngIf="tableList.length ;else emptyState">
                                <ng-container>
                                    <h5 class="mt-2">{{ item?.label }}</h5>
                                    <app-policy-table [keys]="item.tableKeys" [list]="tableList">
                                    </app-policy-table>
                                </ng-container>
                            </ng-container>
                            <ng-template #emptyState>
                                <ng-container>
                                    <h6>{{ item.emptyStateMessage }}</h6>
                                </ng-container>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>